














































import {
	Component,
} from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import BasePicture from './BasePicture';

@Component
export default class Picture extends mixins(BasePicture) {}
